import type { RailId } from '../ids';
import { LOAD_TYPE } from './loadType';
import type { AcceptedLoadTypes } from './loadType';

/**
 * Where a load is wired. A load is bound to exactly one output: either an
 * onboard RCU relay, or a channel on a DIN rail.
 */
export const CHANNEL_KIND = {
  RCU: 'rcu',
  DIN: 'din',
} as const;

export type ChannelKind = (typeof CHANNEL_KIND)[keyof typeof CHANNEL_KIND];

export interface RcuChannelRef {
  readonly kind: typeof CHANNEL_KIND.RCU;
  /** 1-based, within the RCU's configured output count. */
  readonly channel: number;
}

export interface DinChannelRef {
  readonly kind: typeof CHANNEL_KIND.DIN;
  readonly railId: RailId;
  /** 1-based, within the rail's channel count. */
  readonly channel: number;
}

export type ChannelRef = RcuChannelRef | DinChannelRef;

/** Load types an onboard RCU relay output can drive. */
export const RCU_ACCEPTED_LOAD_TYPES: AcceptedLoadTypes = [LOAD_TYPE.RELAY];
